import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const customerGroupsListStyle = StyleSheet.create({
    containerView: {
        flex: 1,
        backgroundColor: "#f8f8f8"
    },
    buttonFont : { 
        fontSize: fontSize?.smallFontSize, 
        fontFamily: appFonts?.bold, 
        color: appColors?.light 
    },
    listContainer: {
        flex: 1,
        borderRadius: 16,
        backgroundColor: appColors.light,
        marginHorizontal: 20,
        marginVertical: 10,
        padding: 20
    },
    titleStyle: { color: appColors.primary, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize },
    badgeStyle: {
        backgroundColor: '#ffedbd',
    },
    badgeTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.lightDark,
    },
    actionView: { flexDirection: 'row', alignSelf: 'flex-end', marginTop: 5, },
    actionIconStyle: {
        borderWidth: 1,
        borderRadius: 11,
        margin: 3,
        padding: 3,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
    headerView: {
        flexDirection: 'row', marginHorizontal: 7,
        marginTop: 10
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginVertical: 13,
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 8,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    filterTextStyle: {
        paddingTop: 3, fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    filterHeaderStyle: { flexDirection: 'row', marginVertical: 5, justifyContent: 'flex-end' },
    filterContainer: { marginVertical: 10, marginHorizontal: 15, borderRadius: 16 },
    filterCommonText: { fontSize: fontSize.smallFontSize, fontFamily: appFonts.bold, paddingHorizontal: 15 },
    filterFooterStyle: {
        flexDirection: 'row', marginVertical: 5, marginHorizontal: 10, justifyContent: "space-between", alignSelf: 'flex-end'
    },
    buttonStyle: { width: 100, height: 40, borderRadius: 7, backgroundColor: appColors.light, },
    editIcon: {
        borderWidth: 1,
        borderRadius: 11,
        paddingHorizontal: 10,
        paddingVertical: 2,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
    deleteIcon: {
        borderWidth: 1,
        borderRadius: 11,
        padding: 8,
        marginHorizontal: 2,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
})